import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  // { name: 'Trang chủ', href: '/' },
  { name: 'Dự đoán', href: '/sport' },
  { name: 'Thể lệ', href: '/rule' },
  { name: 'Kết quả', href: '/prize-structure' }
];

const HeaderMenu = () => {
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const activeNav = location.pathname;
  const isNavItemActive = (href) => activeNav === href || (href === '/sport' && activeNav === '/');
  const mounted = useRef(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.OK9
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          // navItems[0].href = settingsMap.link_home || 'https://ok9.dev/DDTS';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="mt-[15px] md:mt-[30px] w-[96%] md:w-full max-w-[1200px] mx-auto rounded-[25px] md:rounded-[40px] 
             flex flex-row justify-between items-center
             px-[13px] md:px-[26px] py-[8px] md:py-[13px] gap-[5px] md:gap-[10px] 
             h-[60px] md:h-[80px] bg-white"
        style={{
          // giữ nguyên calc vì Tailwind không cover chính xác công thức này
          left: 'calc(50% - 1203px/2 + 0.5px)',
          // inset box-shadow với màu tuỳ chỉnh -> dùng style inline
          boxShadow: 'inset 0px 0px 10px #86B3FE'
        }}
      >
        <div className="flex justify-start w-full md:w-1/5">
          <Link to={'/'}>
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[50px] w-[80%] md:w-auto object-contain"
            />
          </Link>
        </div>

        <div className="flex justify-end items-center w-full">
          <div className="flex flex-row items-center justify-end gap-2 w-full h-full">
            <Link
              to={settings.link_login}
              target="_blank"
              className="w-[90px] h-[26px] md:w-[118px] md:h-[32px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/login.png"
                alt="Đăng nhập"
                className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
            <Link
              to={settings.link_register}
              target="_blank"
              className="w-[100px] h-[32px] md:w-[124px] md:h-[38px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/register.png"
                alt="Đăng ký"
                className="max-w-full max-h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full h-auto flex justify-center items-center">
        <img
          src="/assets/images/header/bannerpc.png"
          alt=""
          className="w-full max-w-[1322px] h-auto object-contain py-2 md:flex hidden"
        />
        <img
          src="/assets/images/header/bannermb.png"
          alt=""
          className="w-full max-w-[375px] h-auto object-contain py-2 md:hidden flex"
        />
      </div>

      <div className="-mt-2 md:-mt-28 flex w-full justify-center px-2 py-1 md:px-0 md:py-2">
        <div
          className="relative flex w-full max-w-[620px] items-center overflow-hidden rounded-[50px] border border-white md:w-auto md:max-w-none mx-1"
          style={{
            boxShadow:
              '0px 2px 5px 0px rgba(14, 93, 236, 0.2), inset 0px -2px 5px 0px rgba(255, 255, 255, 0.2), inset 0px 2px 5px 0px rgba(255, 255, 255, 0.25)'
          }}
        >
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 rounded-[50px] bg-gradient-to-b from-white to-[#EBF4FF]"
          />

          {navItems.map((item, index) => {
            const isActive = isNavItemActive(item.href);
            const prevItem = navItems[index - 1];
            const showDivider =
              index > 0 && prevItem && !isNavItemActive(prevItem.href) && !isActive;

            return (
              <div key={item.name} className="relative flex flex-1 items-stretch md:flex-none">
                {showDivider && (
                  <div className="absolute left-0 top-1/2 z-[1] h-[20px] w-px -translate-y-1/2 bg-gradient-to-b from-transparent via-[#D3E3F7] to-transparent md:h-[30px]" />
                )}
                <Link
                  to={item.href}
                  className={`relative z-[2] flex flex-1 items-center justify-center px-2 py-[8px] text-[12px] font-medium capitalize leading-none transition-colors duration-200 sm:text-[14px] md:w-[155px] md:flex-none md:px-[10px] md:py-[10px] md:text-[20px] ${
                    isActive
                      ? 'bg-gradient-to-b from-[#237AF6] to-[#0B4FD6] text-white'
                      : 'text-[#0043B3] hover:text-[#0043B3]/80'
                  }`}
                >
                  {item.name}
                </Link>
              </div>
            );
          })}

          <div className="relative flex flex-1 items-stretch md:flex-none">
            {!isNavItemActive(navItems[navItems.length - 1]?.href) && (
              <div className="absolute left-0 top-1/2 z-[1] h-[20px] w-px -translate-y-1/2 bg-gradient-to-b from-transparent via-[#D3E3F7] to-transparent md:h-[30px]" />
            )}
            <button
              type="button"
              onClick={() => setIsModalHistory(true)}
              className="relative z-[2] flex flex-1 cursor-pointer items-center justify-center border-0 bg-transparent px-2 py-[8px] text-[12px] font-medium capitalize leading-none text-[#0043B3] transition-colors duration-200 hover:text-[#0043B3]/80 sm:text-[14px] md:w-[155px] md:flex-none md:px-[10px] md:py-[10px] md:text-[20px]"
            >
              Lịch sử
            </button>
          </div>
        </div>
      </div>
      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default HeaderMenu;
